<template>
    <div>
    <div class="block">
        <div class="title">Select ARTIcles</div>
        <div class="body">
            <button class="button btn-primary" @click="modalSearchArticles = true">Add ARTIcles</button>
            <button class="button btn-primary" @click="modalYoutubeLink = true">Add Youtube Video</button>
            <button class="button btn-primary" @click="modalDownload = true">Add Download</button>

            <div>
                <draggable v-model="articles"
                           class="images"
                           :forceFallback="true">
                    <div :class="['image', { 'youtube': item.type === 'video'}]"
                         v-for="(item, index) in articles"
                         :key="index"
                         :style="{'background-image': `url(${getImageLink(item)})` }">

                        <div class="image-title">
                            <template v-if="item.type === 'article'">
                                {{ item.content.title }}
                            </template>
                            <template v-else>
                                {{ item.title }}
                            </template>
                        </div>

                        <template v-if="item.type === 'video'">
                            <iframe width="560" height="315" :src="`${item.video_link}?controls=0`"
                                    title="YouTube video player"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen></iframe>
                        </template>

                        <div class="type-badge">
                            {{ item.type }}
                        </div>

                        <div class="edit-buttons">
                            <div v-if="item.type === 'video'" class="edit-button" @click="editArticle(item)">
                                <span class="ico-i icon-settings"></span>
                            </div>
                            <div class="delete-button" @click="deleteArticle(index)">
                                <span class="ico-i icon-delete"></span>
                            </div>
                        </div>

                    </div>
                </draggable>
                <p class="help">Drag to change the order</p>
            </div>
        </div>
    </div>


    <ModalSearchArticles
        :is-open-modal="modalSearchArticles"
        @selected="selectedArticles"
        @closeModal="modalSearchArticles = false">
    </ModalSearchArticles>
    <ModalWindow :open="modalYoutubeLink" @closeModal="modalYoutubeLink = false">
        <template slot="title">
            Add video from YouTube
        </template>
        <template slot="buttons">
            <button @click="selectedVideo" class="button btn-primary">Add</button>
        </template>
        <template slot="body">
            <div class="formBlock">
                <p class="label">Title</p>
                <input type="text" class="input"
                       v-model="newYoutubeLink.title"
                       :placeholder="'Youtube Video title'">
            </div>
            <div class="formBlock">
                <p class="label">Youtube Video Date</p>
                <date-picker
                    type="date"
                    valueType="format"
                    format="MM/DD/YYYY"
                    v-model="newYoutubeLink.video_date"
                    :placeholder="'Youtube Video Date'"
                />
                <p class="help">Example: 05/20/2022</p>
            </div>
            <div class="formBlock">
                <p class="label">Youtube Video URL</p>
                <input type="text" class="input"
                       v-model="newYoutubeLink.video_link"
                       :placeholder="'Youtube Video URL'">
                <p class="help">Example: <b>https://www.youtube.com/embed/X1silxYgrXo</b></p>
            </div>
            <div class="formBlock">
                <p class="label">Youtube Video ID</p>
                <input type="text" class="input"
                       v-model="newYoutubeLink.video_id"
                       :placeholder="'Youtube Video URL'">
                <p class="help">Example: https://www.youtube.com/embed/<b>X1silxYgrXo</b></p>
            </div>
        </template>
    </ModalWindow>

    <ModalWindow :open="modalEditYoutubeLink" @closeModal="modalEditYoutubeLink = false">
        <template slot="title">
            Edit video from YouTube
        </template>
        <template slot="buttons">
            <button @click="saveVideo" class="button btn-primary">Save</button>
        </template>
        <template slot="body">
            <div class="formBlock">
                <p class="label">Title</p>
                <input type="text" class="input"
                       v-model="editYoutubeLink.title"
                       :placeholder="'Youtube Video title'">
            </div>
            <div class="formBlock">
                <p class="label">Youtube Video Date</p>
                <date-picker
                    type="date"
                    valueType="format"
                    format="MM/DD/YYYY"
                    v-model="editYoutubeLink.video_date"
                    :placeholder="'Youtube Video Date'"
                />
                <p class="help">Example: 05/20/2022</p>
            </div>
            <div class="formBlock">
                <p class="label">Youtube Video URL</p>
                <input type="text" class="input"
                       v-model="editYoutubeLink.video_link"
                       :placeholder="'Youtube Video URL'">
                <p class="help">Example: <b>https://www.youtube.com/embed/X1silxYgrXo</b></p>
            </div>
            <div class="formBlock">
                <p class="label">Youtube Video ID</p>
                <input type="text" class="input"
                       v-model="editYoutubeLink.video_id"
                       :placeholder="'Youtube Video URL'">
                <p class="help">Example: https://www.youtube.com/embed/<b>X1silxYgrXo</b></p>
            </div>
        </template>
    </ModalWindow>

    <ModalAddDownload :is-open="modalDownload"
                      @onModalClose="modalDownload = false"
                      @onSave="saveDownload"/>

    </div>
</template>

<script>
import ModalSearchArticles from "../Utils/ModalSearchArticles";
import ModalWindow from "../Utils/ModalWindow";
import draggable from "vuedraggable";
import ModalAddDownload from "../Utils/ModalAddDownload.vue";
import FormMethodsDefault from "../Utils/Page/Form/FormMethodsDefault";
import _ from "lodash";


export default {
    name: "ArticlesSliderSection",
    mixins: [FormMethodsDefault],
    components: {
        ModalAddDownload,
        ModalSearchArticles,
        ModalWindow,
        draggable
    },
    props: {
        targetPage: {
            type: String
        }
    },
    data() {
        return {
            lang: this.$ml.get('pages.homepage'),

            modalEditYoutubeLink: false,
            editYoutubeLink: {
                title: '',
                video_link: '',
                video_id: '',
                video_date: '',
                type: 'video',
            },

            modalYoutubeLink: false,
            newYoutubeLink: {
                title: '',
                video_link: '',
                video_id: '',
                video_date: '',
                type: 'video',
            },

            modalSearchArticles: false,

            buttons: [],

            typeForm: {},

            //pageRouteList: 'homepage',
            //pageRouteEdit: 'homepage.edit',
            pageApi: this.targetPage,
            pagePermission: this.targetPage,

            articles: [],

            modalDownload: false,
        }
    },

    watch: {
        'newYoutubeLink.video_link'(val) {
            this.testYoutubeLink(val, this.newYoutubeLink)
        },
        'editYoutubeLink.video_link'(val) {
            this.testYoutubeLink(val, this.editYoutubeLink)
        }
    },

    methods: {
        testYoutubeLink(val, item) {
            if (!val) return

            let pattern = [
                'youtu\\.be\/(.*)',
                'youtube\\.com\/embed\/(.*)',
                'youtube\\.com\/watch\\?v=([0-9A-z]+)',
            ]
            pattern = pattern.join('|')
            let regex = new RegExp(pattern)

            let link = val
            let matches
            if (regex.test(link)) {
                matches = link.match(pattern)
            }
            if (matches[1] || matches[2] || matches[3]) {
                item.video_id = matches[1] ?? matches[2] ?? matches[3]
                item.video_link = `https://www.youtube.com/embed/${item.video_id}`
            }
        },

        editArticle(item) {
            this.editYoutubeLink = Object.assign({}, item)
            this.modalEditYoutubeLink = true
        },
        deleteArticle(index) {
            this.articles.splice(index, 1)
        },
        selectedArticles(item) {
            this.modalSearchArticles = false

            let data = {
                type: 'article',
                content_id: item.id,
                content: item,
                id: 'add_' + Math.abs(Math.ceil(Math.random() * (1000 - 9999) + 1000))
            }

            this.articles.push(data)
        },
        saveVideo() {
            let id = this.articles.findIndex(el => el.id === this.editYoutubeLink.id)
            if (id !== -1) {
                this.articles[id] = Object.assign({}, this.editYoutubeLink)
            }
            this.modalEditYoutubeLink = false
            this.editYoutubeLink = {
                type: 'video',
                title: '',
                video_link: '',
                video_id: '',
            }
        },
        selectedVideo() {
            this.modalYoutubeLink = false

            let data = Object.assign({}, this.newYoutubeLink)
            data.id = 'add_' + Math.abs(Math.ceil(Math.random() * (1000 - 9999) + 1000))

            this.articles.push(data)

            this.newYoutubeLink = {
                type: 'video',
                title: '',
                video_link: '',
                video_id: '',
            }
        },

        getMediaUrl(media) {
            return media.preview_url_cdn_query ?? media.url_preview ?? media.url
        },
        setExtraDataCreate() {
            this.articles = this.dictionaries.articles
        },
        saveDownload(download) {
            console.log('dwnlf', download)
            this.articles.push(_.cloneDeep(download))
        },
        saveForm(callback) {
            let access = false
            if (this.id) {
                access = this.getPermissionSection('edit')
            } else {
                access = this.getPermissionSection('create')
            }
            if (!access) {
                this.$store.commit('setNotification', {
                    type: 'error',
                    message: 'Permission denied'
                })
                return;
            }

            let form = new FormData()

            this.articles.forEach((article, index) => {
                form.append('articles[]', JSON.stringify(_.omit(article, ['content', 'file', 'image'])))
                form.append(
                    `articles_${index}_file`,
                    article.file
                )
                form.append(
                    `articles_${index}_image`,
                    article.image
                )
            })

            if (!this.articles.length) {
                form.append('articles[]', null)
            }

            this.$store.commit('setLoading', true)
            axios.post(this.$store.getters.getApiUrl(this.pageApi), form)
                .then(({data, response}) => {
                    if (data && data.success) {
                        if (!this.id && data.element?.id) {
                            this.id = data.element.id
                            this.$router.push({name: this.pageRouteEdit, params: {id: data.element.id}})
                        }
                        this.getData()
                        this.$store.commit('setNotification', {
                            type: 'success',
                            message: this.$ml.get('interface.saved')
                        })
                    } else {
                        this.$store.commit('setErrorMessage',
                            data ? data.message : response.data ? response.data.message : 'Unknown error')
                    }
                })
                .finally(() => {
                    this.$store.commit('setLoading', false)
                    if (callback)
                        callback();
                })
        },
        getImageLink(item) {
            if (item.content?.image) {
                return item.content.image
            }
            if (item.download_image_link) {
                return item.download_image_link
            }
            return ''
        }
    }
}
</script>

